// / eslint-disable @typescript-eslint/no-explicit-any /
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomFacade, noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { cloneDeep } from 'lodash';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { delayedFunctionCall } from 'libs/shared/src/lib/service/helper.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { CustomMaterialsDataGridService } from '@piqet-angular/features';
@Component({
  selector: 'piqet-angular-new-custom-material',
  templateUrl: './new-custom-material.component.html',
  styleUrls: ['./new-custom-material.component.scss'],
})
export class NewCustomMaterialComponent implements OnInit, OnDestroy {
  addNewCustomMaterialForm!: FormGroup;
  submitted = false;
  materialList: any;
  materialColumnDef: any;
  processColumnDef: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  showEdit = false;
  showCreate = false;
  showView = false;
  checkEntireAccess = false;
  headerBtn = 'Add row';
  headerBtnName = 'customMaterialIngredient';
  headerBtnNameForProcess = 'customMaterialProcess';
  disableSubmit = false;
  frameworkComponents = {
    // actionRenderer: ActionButtonComponent,
    inlineActionButtonComponent: InlineActionButtonComponent,
    dropdownRendered: GridCellDropdownComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  ingredientFormSubmitted = false;
  processFormSubmitted = false;
  ingredientIndex: any;
  materialIngredientForm: any;
  processForm: any;
  finalSubmitted = false;
  modalLabel: any;
  customData: any = [];
  customMaterialId: any;
  errorNotification!: string;
  ingredientId: any;
  materialTypeId: any;
  activatedRoute: any;
  organizationlist: any;
  selectOrganization: any;
  gridName = 'Custom process grid';
  gridNameMaterial = 'Custom ingredient grid';
  isHideSideBar = true;
  setOrganizationValue: any;
  selectedDropDownValue: any;
  showGrid: any;
  fromEdit: any;
  ownerName: any;
  packageCostSum: any;
  disableSubscription!: Subscription;
  useDefaultDataSource = true;

  @Output() saveCustoMaterialEvent = new EventEmitter<{
    payload: any;
    pathName: any;
  }>();
  isRowEditable = false;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    private customMaterialDataGridService: CustomMaterialsDataGridService,
    public spinnerService: NgxSpinnerService,
    private swalService: SwalService,
    private sharedService: SharedService,
    private cookieService: CookieService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.isHideDropDown = this.activatedRoute == 'adminCustomMaterials' ? true : false;
    this.materialColumnDef = this.modal?.modalService?.config?.initialState?.['materialColDef'];
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom material' ? true : false;
    this.customData = this.modal?.modalService?.config?.initialState?.['newCustomMaterialData'];
    this.ownerName = this.customData.hasOwnProperty('ownerName')
      ? this.customData.ownerName
      : this.modal?.modalService?.config?.initialState?.['ownerName'];
    this.packageCostSum = this.customData.hasOwnProperty('packageCostSum')
      ? this.customData.packageCostSum
      : 0;
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.customFacade.newCustomMaterialData$.subscribe(res => {
      this.customData =
        (res.hasOwnProperty('length') && res.length) ||
        (res && res.customMaterialId) ||
        !this.fromEdit
          ? res
          : this.customData;
      this.initializeFormData();
    });
  }

  ngOnInit(): void {
    this.showEdit = this.customMaterialDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.customMaterialDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.customMaterialDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
  }

  initializeFormData() {
    this.customFacade.organizationItems$.subscribe((response: any) => {
      this.organizationlist = response;
    });
    this.addNewCustomMaterialForm = this.formBuilder.group({
      materialName: [this.customData?.name ?? null, [Validators.required, noWhitespaceValidator]],
      description: [this.customData?.description || ''],
      source: [this.customData?.customDataSource?.source ?? ''],
      timePeriod: [this.customData?.customDataSource?.timePeriod ?? ''],
      geography: [this.customData?.customDataSource?.geography ?? ''],
      process: [this.customData?.customDataSource?.process ?? ''],
      organizationName: ['', Validators.required],
      mainMaterial: [this.customData?.mainMaterialId ?? null, Validators.required],
      materialIngredientForm: this.formBuilder.group({
        customMaterial: [null, Validators.required],
        weight: [null, Validators.required],
        recycledContent: [0, [Validators.min(0), Validators.max(100), Validators.maxLength(30)]],
        scrapWeight: [0, [Validators.required, Validators.maxLength(30)]],
        costPerKgCM: [0, [Validators.maxLength(30)]],
        packageCost: [{ value: null, disabled: true }],
      }),
      processForm: this.formBuilder.group({
        process: [null, Validators.required],
        amount: [null, Validators.required],
        costPerKgManufacture: [0, Validators.required],
        costShare: [null, Validators.required],
      }),
    });
    this.customMaterialId = this.customData?.customMaterialId;
    this.useDefaultDataSource = this.customData?.useDefaultDataSource ?? true;
    this.organizatioListFunction();
    this.setFormData();
    this.setOrganizationValue = this.selectOrganization;
    this.selectedDropDownValue = this.selectOrganization;

    this.customFacade.copiedMaterialIngredient$.subscribe((ingredient: any) => {
      if (ingredient) {
        this.ingredientIndex = ingredient?.index;
        this.ingredientId = ingredient?.id;
        this.addNewCustomMaterialForm.get('materialIngredientForm')?.patchValue({
          customMaterial: ingredient.materialName,
          weight: ingredient.weight,
          recycledContent: ingredient.recycledContent,
          scrapWeight: ingredient.scrapedWeight,
          costPerKgCM: ingredient.cost,
          packageCost: ingredient.packageCost,
        });
      }
    });

    this.materialIngredientForm = this.addNewCustomMaterialForm.controls['materialIngredientForm'];
    this.processForm = this.addNewCustomMaterialForm.controls['processForm'];

    this.customFacade.customMaterialIngredirentError$.subscribe((error: any) => {
      this.checkValidation(error);
    });

    this.customFacade.GetCustomMaterialProcessError$.subscribe((error: any) => {
      this.checkValidationForProcess(error);
    });

    this.customFacade.materialItems$.subscribe((data: any) => {
      this.materialList = data;
      this.materialColumnDef = cloneDeep(this.materialColumnDef);
      this.materialColumnDef[0].cellEditorParams['materialIngredientList'] = data;
    });

    this.customFacade.endofLifeIdentifierItems$.subscribe((data: any) => {
      const eolItems = cloneDeep(data);
      this.materialColumnDef.forEach((item: any) => {
        if (item.field === 'endofLifeIdentifierName') {
          item.cellEditorParams['endofLifeIdentifierName'] = eolItems;
        }
      });
      this.materialColumnDef = [...this.materialColumnDef];
    });

    this.customFacade.energyItems$.subscribe((energyItems: any) => {
      this.processColumnDef = cloneDeep(this.processColumnDef);
      this.processColumnDef[0].cellEditorParams['materialProcessList'] = energyItems;
    });

    this.disableSubscription = this.sharedService.disableAddRowBtnTrigger$.subscribe(
      (error: any) => {
        this.checkEditingStatus(error);
      }
    );
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == (this.customData.organizationId || this.cookieService.get('organizationId'))) {
        return (this.selectOrganization = item);
      }
    });
  }

  setFormData() {
    this.addNewCustomMaterialForm.patchValue({
      organizationName: this.selectOrganization,
    });
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForOrganization(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }
  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }

  checkValidation(materialIngredientError?: any): void {
    if (materialIngredientError) {
      this.disableSubmit = true;
    }
  }

  checkValidationForProcess(materialProcessError?: any): void {
    if (materialProcessError) {
      this.disableSubmit = true;
    }
  }

  onSave(materialIngredientList: any, materialProcessList: any) {
    delayedFunctionCall(this.delayedSave, 0, this, materialIngredientList, materialProcessList);
  }

  delayedSave(materialIngredientList: any, materialProcessList: any) {
    this.finalSubmitted = true;
    this.processFormSubmitted = false;
    this.ingredientFormSubmitted = false;
    if (
      this.activatedRoute == 'adminCustomMaterials' &&
      (!this.addNewCustomMaterialForm.controls['organizationName'].valid ||
        this.addNewCustomMaterialForm.controls['organizationName'].value?.name == 'Organization')
    ) {
      return;
    }
    if (!materialIngredientList.length) {
      this.customFacade.setCustomMaterialError('Please add atleast one material ingredient.');
      this.disableSubmit = false;
      return;
    } else if (
      materialIngredientList
        ?.map((el: any) => {
          return el.weight;
        })
        ?.reduce((a: any, b: any) => a + b) != 1000
    ) {
      this.customFacade.setCustomMaterialError(
        'Total weight of materials should add up to 1000 grams (1 kg).'
      );
      this.disableSubmit = false;
      return;
    }

    // Check if scrapedWeight > 0 but endofLifeIdentifierId is missing
    const hasScrapValidationError = materialIngredientList.some(
      (item: any) => item?.scrapedWeight > 0 && !item?.endofLifeIdentifierId
    );

    if (hasScrapValidationError) {
      this.customFacade.setCustomMaterialError(
        'Destination of scrap is required when scraped weight is greater than zero.'
      );
      this.disableSubmit = false;
      return;
    }

    if (
      this.addNewCustomMaterialForm.errors == null &&
      this.addNewCustomMaterialForm.controls['materialName'].valid &&
      this.addNewCustomMaterialForm.controls['mainMaterial'].valid
    ) {
      this.modal.close();
      const customDataSource = {
        source: !this.useDefaultDataSource
          ? this.addNewCustomMaterialForm.value.source?.trim() ?? ''
          : '',
        timePeriod: !this.useDefaultDataSource
          ? this.addNewCustomMaterialForm.value.timePeriod?.trim() ?? ''
          : '',
        geography: !this.useDefaultDataSource
          ? this.addNewCustomMaterialForm.value.geography?.trim() ?? ''
          : '',
        process: !this.useDefaultDataSource
          ? this.addNewCustomMaterialForm.value.process?.trim() ?? ''
          : '',
      };
      const saveCustomMaterialData = {
        customMaterialId: this.customMaterialId,
        name: this.addNewCustomMaterialForm.value.materialName.trimStart(),
        description: this.addNewCustomMaterialForm.value.description.trimStart(),
        useDefaultDataSource: this.useDefaultDataSource,
        customDataSource: customDataSource,
        materialIngrediantsItems: materialIngredientList,
        materialProcessItems: materialProcessList,
        organizationId:
          this.addNewCustomMaterialForm.controls['organizationName'].value?.id ||
          this.customData.organizationId ||
          this.cookieService.get('organizationId'),
        mainMaterialId: this.addNewCustomMaterialForm.value.mainMaterial,
        packageCostSum: this.packageCostSum,
        ownerName: this.ownerName,
      };
      this.saveCustoMaterialEvent.emit({
        payload: saveCustomMaterialData,
        pathName: this.activatedRoute,
      });

      this.finalSubmitted = false;
    }
  }

  checkEditingStatus(err: any) {
    // if any row in the grid is in edit mode then disable the add row button and save button
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  toggleDataSource(event: any) {
    this.useDefaultDataSource = event.target.checked;
  }

  ngOnDestroy(): void {
    this.customFacade.clearMaterialRowData();
    this.disableSubscription.unsubscribe();
  }
}
